// Sidebar navigation component with sections
// Created as part of ENG2-1699: Create AppLayout Component with Sidebar

import React from 'react'
import { Box, Typography } from '@mui/material'
import SidebarNavItem from './sidebar-nav-item'
import { SidebarNavProps } from './sidebar.types'

const SidebarNav: React.FC<SidebarNavProps> = ({ sections, currentPath }) => {
  return (
    <Box
      component="nav"
      sx={{
        flex: 1,
        padding: '12px 10px',
        overflowY: 'auto',
        // Custom scrollbar for nav
        '&::-webkit-scrollbar': {
          width: '4px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          borderRadius: '2px',
        },
      }}
    >
      {sections.map((section) => (
        <Box key={section.section}>
          {/* Section label */}
          <Typography
            sx={{
              fontSize: '11px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              color: 'rgba(255, 255, 255, 0.35)',
              padding: '16px 12px 6px',
            }}
          >
            {section.section}
          </Typography>

          {/* Section items */}
          {section.items.map((item) => (
            <SidebarNavItem
              key={item.path}
              item={item}
              isActive={currentPath === item.path}
            />
          ))}
        </Box>
      ))}
    </Box>
  )
}

export default SidebarNav
